import { AMCFundStatusUtil } from "_fil_local_addon/camc-cms-base/index";
import CAMCFundManager from "./camc-fund-managers";

class WebsiteCAMCFundManager extends CAMCFundManager {
    errorHandler() {
        showApiMessageing(this.$fundManager);
        this.$fundManager.removeClass("invisible").css("margin-left", "-15px");
    }

    renderMultiManagerTemplate(displayedFundManagerData) {
        for (let j = 0; j < displayedFundManagerData.length; j++) {
            if (j % 2 == 0) {
                $(".fund-manager").eq(j).find(".text-left.right.grey").removeClass("right grey").addClass("left");
                $(".fund-manager").eq(j).find(".cell.one").remove();
            } else {
                $(".fund-manager").eq(j).find(".cell.two").remove();
            }
            $(".fund-manager").eq(j).find(".manager-name").html(displayedFundManagerData[j].name);
            $(".fund-manager").eq(j).find(".manager-position").html(displayedFundManagerData[j].title);
            $(".fund-manager").eq(j).find(".manager-bio").html(displayedFundManagerData[j].biography);
            $(".fund-manager")
                .eq(j)
                .find(".manager-img")
                .attr("src", "/" + displayedFundManagerData[j].photo);
            $(".fund-manager")
                .eq(j)
                .find(".manager-view")
                .attr("href", " /news-and-insights/investment-analysis?tag=" + displayedFundManagerData[j].name);
            $(".fund-manager").eq(j).removeClass("invisible");
        }
    }
    renderOneManagerTemplate(displayedFundManagerData) {
        $(".cell.two").remove();
        $(".manager-name").html(displayedFundManagerData[0].name);
        $(".manager-position").html(displayedFundManagerData[0].title);
        $(".manager-bio").html(displayedFundManagerData[0].biography);
        $(".manager-img").attr("src", "/" + displayedFundManagerData[0].photo);
        $(".fund-manager")
            .find(".manager-view")
            .attr("href", " /news-and-insights/investment-analysis?tag=" + displayedFundManagerData[0].name);
        $(".fund-manager").removeClass("invisible");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if (window.fundCode) {
        let camcFundManager = new WebsiteCAMCFundManager(window.fundCode);
        camcFundManager.render();
    }
});

export default WebsiteCAMCFundManager;
